<style scoped lang="less">
  .franchiseSelector div {
    min-width: 275px;
  }

  @media (max-width: 767px) {
    .franchiseSelector div {
      min-width: 200px;
    }
  }
</style>
<template>
  <div class="content pr-2">
    <div
      v-if="!franchises.length"
      class="spinner-loader"
    >
      <sync-loader />
      <p>Loading ...</p>
    </div>
    <div
      v-if="franchises.length"
      class="box"
    >
      <div class="column card-header has-text-centered button-tools">
        <strong>Approve Tournaments</strong>
      </div>
      <div class="columns">
        <div class="column is-6 is-flex franchiseSelector">
          <span><strong>Franchise:</strong>&nbsp;&nbsp;</span>
          <v-select
            v-model="selectedFranchise"
            :options="franchises"
            label="name"
            @input="getTournamentsNeedingApproval"
          />
        </div>
      </div>
    </div>
    <div
      v-if="franchises.length > 0 && tourns.length == 0"
      class="text-center"
    >
      <span>There were no missing tournaments located.</span>
    </div>
    <div v-for="tourn in tourns">
      <tournament-card
        :token="token"
        :tourn-data="tourn"
        delete-button="true"
        edit-button="true"
        approve-tournament="true"
        invoice-button="true"
      />
    </div>
  </div>
</template>

<script>
  import vSelect from 'vue-select'
  import TournamentCard from './TournamentCard.vue'
  import axios from 'axios'

  export default {
    name: 'ToolsTournamentApprove',
    components: {
      TournamentCard,
      vSelect
    },
    props: ['token', 'user'],
    data() {
      return {
        franchises: [],
        selectedFranchise: {id: null, name: ''},
        tourns: [],
      }
    },
    computed: {},
    created() {
      if (!this.user || !this.user.isHost) this.$router.push({name: 'FourZeroFour'})
    },
    mounted() {
      this.getFranchises()
    },
    methods: {
      franchiseChanged() {
        console.log('Franchise Changed')
      },
      getTournamentsNeedingApproval() {
        let url = `admin/tournaments/gettournaments/approval`
        let data = {
          token: this.token,
          franchise: this.selectedFranchise.id
        }
        this.$axios({
          method: 'POST',
          url,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data
        })
          .then((res) => {
            this.tourns = res.data
          })
          .catch((error) => {
            this.$emit('message',
              {
                showDialog: true,
                error: true,
                message: error.response.data.message
              })
          })
      },
      getFranchises() {
        let url = `admin/tournaments/getfranchises`
        let data = {
          token: this.token,

        }
        this.$axios({
          method: 'POST',
          url,
          headers: {
            Authorization: '84cd7a9a97d4c1d8f6402f9389711560',
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          data
        })
          .then((res) => {
            this.franchises = res.data
            this.selectedFranchise = res.data[0]
            this.getTournamentsNeedingApproval()
          })
          .catch((error) => {
            this.$emit('message', {error: true, showDialog: true, message: error.response.data.message})
          })
      }
    }
  }
</script>
